const BattleKartFootSVGIcon = () => {
  return (
    <svg id="Asset" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 228.49 229.44">
      <defs>
        <style>
          {`
                        .cls-1, .cls-2 {
                            fill: #470C00;
                        }
                        .cls-3 {
                            fill: #F9F9FA;
                        }
                        .cls-2 {
                            stroke: #470C00;
                            stroke-miterlimit: 10;
                            stroke-width: 2.72px;
                        }
                        .cls-4 {
                            fill: url(#linear-gradient);
                        }
                        .cls-5 {
                            fill: #fff;
                        }
                        .cls-6 {
                            fill: url(#Dégradé_sans_nom_29);
                        }
                        .cls-7 {
                            fill: url(#Dégradé_sans_nom_39);
                        }
                        .cls-8 {
                            fill: #13100D;
                            opacity: .5;
                        }
                    `}
        </style>
        <linearGradient id="linear-gradient" x1="114.31" y1="222.06" x2="114.31" y2="6.75" gradientTransform="translate(-.07 0)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0078AE" />
          <stop offset="1" stopColor="#69C8F3" />
        </linearGradient>
        <linearGradient
          id="Dégradé_sans_nom_29"
          data-name="Dégradé sans nom 29"
          x1="114.31"
          y1="228.48"
          x2="114.31"
          y2="0"
          gradientTransform="translate(-.07 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#2C0800" />
          <stop offset="1" stopColor="#470C00" />
        </linearGradient>
        <linearGradient
          id="Dégradé_sans_nom_39"
          data-name="Dégradé sans nom 39"
          x1="114.31"
          y1="229.43"
          x2="114.31"
          y2="110.38"
          gradientTransform="translate(-.07 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".26" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" stopOpacity=".6" />
        </linearGradient>
      </defs>
      <g>
        <rect className="cls-4" x="6.89" y="6.89" width="214.71" height="214.71" rx="25.68" ry="25.68" />
        <path
          className="cls-8"
          d="M13.77,121.14V37.35c0-9.2,7.48-16.68,16.67-16.68h167.58c9.2-.01,16.68,7.47,16.68,16.67v83.79s13.77,0,13.77,0V37.33c0-16.79-13.67-30.45-30.46-30.45H30.45C13.66,6.9,0,20.56,0,37.35v83.79s13.77,0,13.77,0Z"
        />
        <path
          className="cls-6"
          d="M198.04,228.48H30.46C13.67,228.49.01,214.83.01,198.04V30.46C0,13.67,13.66.01,30.45.01h167.58c16.79-.01,30.45,13.64,30.45,30.43v167.58c.01,16.79-13.64,30.45-30.43,30.45ZM30.45,13.78c-9.2,0-16.68,7.48-16.68,16.68v167.58c.01,9.2,7.5,16.68,16.7,16.68h167.58c9.2-.01,16.68-7.5,16.68-16.7V30.45c-.01-9.2-7.5-16.68-16.7-16.68H30.45Z"
        />
        <path className="cls-7" d="M18.6,156.91v60.67c0,6.54,5.33,11.86,11.86,11.86h167.58c6.54-.01,11.86-5.33,11.86-11.87v-107.03c-92.12-2.38-153.48,22.12-191.3,46.38Z" />
      </g>
      <g>
        <circle className="cls-3" cx="114.27" cy="114.74" r="75.84" />
        <circle className="cls-5" cx="114.27" cy="114.74" r="75.84" />
        <path
          className="cls-1"
          d="M184.55,121.55h-23.03c-3.76,0-6.81-3.05-6.81-6.81h0c0-3.76,3.05-6.81,6.81-6.81h23.03c1.13,0,2.05.92,2.05,2.05v9.53c0,1.13-.92,2.05-2.05,2.05ZM107.58,44.33v23.03c0,3.76,3.05,6.81,6.81,6.81h0c3.76,0,6.81-3.05,6.81-6.81v-23.03c0-1.13-.92-2.05-2.05-2.05h-9.53c-1.13,0-2.05.92-2.05,2.05ZM43.98,121.3h23.03c3.76,0,6.81-3.05,6.81-6.81h0c0-3.76-3.05-6.81-6.81-6.81h-23.03c-1.13,0-2.05.92-2.05,2.05v9.53c0,1.13.92,2.05,2.05,2.05ZM120.95,184.9v-23.03c0-3.76-3.05-6.81-6.81-6.81h0c-3.76,0-6.81,3.05-6.81,6.81v23.03c0,1.13.92,2.05,2.05,2.05h9.53c1.13,0,2.05-.92,2.05-2.05Z"
        />
        <g>
          <path
            className="cls-1"
            d="M44.85,92.06c1.56-3.53,3.36-7.01,5.4-10.4,5.09-8.44,11.33-15.75,18.4-21.87,7.01-6.09,14.83-11,23.16-14.65.06.24.11.47.16.71,2.44,9.55,1.22,20.04-4.27,29.15-9.04,15-26.77,21.53-42.86,17.07Z"
          />
          <path
            className="cls-1"
            d="M46.41,88.79c1.4-3.17,3.01-6.29,4.85-9.33,4.57-7.57,10.16-14.13,16.51-19.62,6.29-5.47,13.31-9.87,20.78-13.15.05.21.1.43.15.64,2.19,8.57,1.1,17.98-3.83,26.15-8.11,13.46-24.02,19.32-38.45,15.31Z"
          />
          <path
            className="cls-1"
            d="M46.41,88.79c1.4-3.17,3.01-6.29,4.85-9.33,4.57-7.57,10.16-14.13,16.51-19.62,6.29-5.47,13.31-9.87,20.78-13.15.05.21.1.43.15.64,2.19,8.57,1.1,17.98-3.83,26.15-8.11,13.46-24.02,19.32-38.45,15.31Z"
          />
        </g>
        <g>
          <path
            className="cls-1"
            d="M91.42,185.17c-3.53-1.56-7.01-3.36-10.4-5.4-8.44-5.09-15.75-11.33-21.87-18.4-6.09-7.01-11-14.83-14.65-23.16.24-.06.47-.11.71-.16,9.55-2.44,20.04-1.22,29.15,4.27,15,9.04,21.53,26.77,17.07,42.86Z"
          />
          <path
            className="cls-1"
            d="M88.15,183.61c-3.17-1.4-6.29-3.01-9.33-4.85-7.57-4.57-14.13-10.16-19.62-16.51-5.47-6.29-9.87-13.31-13.15-20.78.21-.05.43-.1.64-.15,8.57-2.19,17.98-1.1,26.15,3.83,13.46,8.11,19.32,24.02,15.31,38.45Z"
          />
          <path
            className="cls-1"
            d="M88.15,183.61c-3.17-1.4-6.29-3.01-9.33-4.85-7.57-4.57-14.13-10.16-19.62-16.51-5.47-6.29-9.87-13.31-13.15-20.78.21-.05.43-.1.64-.15,8.57-2.19,17.98-1.1,26.15,3.83,13.46,8.11,19.32,24.02,15.31,38.45Z"
          />
        </g>
        <g>
          <path
            className="cls-1"
            d="M184.52,138.6c-1.56,3.53-3.36,7.01-5.4,10.4-5.09,8.44-11.33,15.75-18.4,21.87-7.01,6.09-14.83,11-23.16,14.65-.06-.24-.11-.47-.16-.71-2.44-9.55-1.22-20.04,4.27-29.15,9.04-15,26.77-21.53,42.86-17.07Z"
          />
          <path
            className="cls-1"
            d="M182.97,141.87c-1.4,3.17-3.01,6.29-4.85,9.33-4.57,7.57-10.16,14.13-16.51,19.62-6.29,5.47-13.31,9.87-20.78,13.15-.05-.21-.1-.43-.15-.64-2.19-8.57-1.1-17.98,3.83-26.15,8.11-13.46,24.02-19.32,38.45-15.31Z"
          />
          <path
            className="cls-1"
            d="M182.97,141.87c-1.4,3.17-3.01,6.29-4.85,9.33-4.57,7.57-10.16,14.13-16.51,19.62-6.29,5.47-13.31,9.87-20.78,13.15-.05-.21-.1-.43-.15-.64-2.19-8.57-1.1-17.98,3.83-26.15,8.11-13.46,24.02-19.32,38.45-15.31Z"
          />
        </g>
        <g>
          <path
            className="cls-1"
            d="M137.96,45.5c3.53,1.56,7.01,3.36,10.4,5.4,8.44,5.09,15.75,11.33,21.87,18.4,6.09,7.01,11,14.83,14.65,23.16-.24.06-.47.11-.71.16-9.55,2.44-20.04,1.22-29.15-4.27-15-9.04-21.53-26.77-17.07-42.86Z"
          />
          <path
            className="cls-1"
            d="M141.23,47.05c3.17,1.4,6.29,3.01,9.33,4.85,7.57,4.57,14.13,10.16,19.62,16.51,5.47,6.29,9.87,13.31,13.15,20.78-.21.05-.43.1-.64.15-8.57,2.19-17.98,1.1-26.15-3.83-13.46-8.11-19.32-24.02-15.31-38.45Z"
          />
          <path
            className="cls-1"
            d="M141.23,47.05c3.17,1.4,6.29,3.01,9.33,4.85,7.57,4.57,14.13,10.16,19.62,16.51,5.47,6.29,9.87,13.31,13.15,20.78-.21.05-.43.1-.64.15-8.57,2.19-17.98,1.1-26.15-3.83-13.46-8.11-19.32-24.02-15.31-38.45Z"
          />
        </g>
        <path
          className="cls-5"
          d="M85.54,111.21c-2.66,0-4.63-2.51-3.95-5.09.8-3.04,2.03-6.01,3.74-8.83,4.71-7.81,12.1-13.03,20.28-15.2,2.59-.69,5.13,1.26,5.13,3.94h0c0,1.87-1.27,3.47-3.08,3.95-6.19,1.65-11.78,5.61-15.35,11.52-1.28,2.13-2.22,4.37-2.82,6.65-.48,1.8-2.08,3.05-3.94,3.05h0ZM110.52,143.55c0-1.86-1.26-3.47-3.05-3.94-2.29-.61-4.53-1.54-6.65-2.82-5.91-3.56-9.86-9.15-11.52-15.35-.48-1.8-2.08-3.08-3.95-3.08h0c-2.68,0-4.63,2.54-3.94,5.13,2.17,8.19,7.39,15.57,15.2,20.28,2.82,1.7,5.79,2.94,8.83,3.74,2.57.68,5.09-1.29,5.09-3.95h0ZM142.86,118.57c-1.86,0-3.47,1.26-3.94,3.05-.61,2.29-1.54,4.53-2.82,6.65-3.56,5.91-9.15,9.86-15.35,11.52-1.8.48-3.08,2.08-3.08,3.95h0c0,2.68,2.54,4.63,5.13,3.94,8.19-2.17,15.57-7.39,20.28-15.2,1.7-2.82,2.94-5.79,3.74-8.83.68-2.57-1.29-5.09-3.95-5.09h0ZM117.89,86.23c0,1.86,1.26,3.47,3.05,3.94,2.29.61,4.53,1.54,6.65,2.82,5.91,3.56,9.86,9.15,11.52,15.35.48,1.8,2.08,3.08,3.95,3.08h0c2.68,0,4.63-2.54,3.94-5.13-2.17-8.19-7.39-15.57-15.2-20.28-2.82-1.7-5.79-2.94-8.83-3.74-2.57-.68-5.09,1.29-5.09,3.95h0Z"
        />
        <circle className="cls-1" cx="114.27" cy="114.74" r="11.68" />
        <path
          className="cls-1"
          d="M114.14,195.81c-14.25,0-28.67-3.75-41.74-11.63-18.55-11.19-31.63-28.92-36.84-49.95-5.21-21.02-1.91-42.82,9.27-61.37,11.19-18.55,28.92-31.63,49.95-36.84,21.02-5.2,42.82-1.91,61.37,9.27,38.29,23.09,50.65,73.03,27.56,111.32-15.21,25.22-42.07,39.19-69.57,39.19ZM77.81,175.19c33.33,20.1,76.8,9.34,96.91-23.99,20.1-33.33,9.34-76.8-23.99-96.91-16.15-9.74-35.12-12.61-53.42-8.07-18.3,4.53-33.75,15.92-43.48,32.07-9.74,16.15-12.6,35.12-8.07,53.42,4.53,18.3,15.92,33.75,32.07,43.48h0Z"
        />
        <path
          className="cls-1"
          d="M114.24,129.96c-2.67,0-5.38-.7-7.83-2.18h0c-3.48-2.1-5.94-5.43-6.91-9.37-.98-3.95-.36-8.04,1.74-11.52,2.1-3.48,5.43-5.94,9.37-6.91,3.95-.98,8.04-.36,11.52,1.74,3.48,2.1,5.94,5.43,6.91,9.37.98,3.95.36,8.04-1.74,11.52-2.85,4.73-7.9,7.36-13.06,7.36ZM108.81,123.8c2.42,1.46,5.26,1.89,8.01,1.21,2.74-.68,5.06-2.39,6.52-4.81,1.46-2.42,1.89-5.26,1.21-8.01-.68-2.74-2.39-5.06-4.81-6.52-2.42-1.46-5.26-1.89-8.01-1.21-2.74.68-5.06,2.39-6.52,4.81-1.46,2.42-1.89,5.26-1.21,8.01.68,2.74,2.39,5.06,4.81,6.52h0Z"
        />
        <path
          className="cls-1"
          d="M187.65,122.6h-26.13c-4.33,0-7.86-3.53-7.86-7.86s3.53-7.86,7.86-7.86h26.13v15.72ZM161.52,108.98c-3.18,0-5.76,2.58-5.76,5.76s2.58,5.76,5.76,5.76h24.03v-11.52h-24.03Z"
        />
        <path
          className="cls-1"
          d="M114.39,75.22c-4.33,0-7.86-3.53-7.86-7.86v-26.13h15.72v26.13c0,4.33-3.53,7.86-7.86,7.86ZM108.63,43.33v24.03c0,3.18,2.58,5.76,5.76,5.76s5.76-2.58,5.76-5.76v-24.03h-11.52Z"
        />
        <path
          className="cls-1"
          d="M67.01,122.35h-26.13v-15.72h26.13c4.33,0,7.86,3.53,7.86,7.86s-3.53,7.86-7.86,7.86ZM42.98,120.25h24.03c3.18,0,5.76-2.58,5.76-5.76s-2.58-5.76-5.76-5.76h-24.03v11.52Z"
        />
        <path
          className="cls-1"
          d="M122,188h-15.72v-26.13c0-4.33,3.53-7.86,7.86-7.86s7.86,3.53,7.86,7.86v26.13ZM108.38,185.9h11.52v-24.03c0-3.18-2.58-5.76-5.76-5.76s-5.76,2.58-5.76,5.76v24.03Z"
        />
        <path
          className="cls-2"
          d="M85.54,111.21c-2.66,0-4.63-2.51-3.95-5.09.8-3.04,2.03-6.01,3.74-8.83,4.71-7.81,12.1-13.03,20.28-15.2,2.59-.69,5.13,1.26,5.13,3.94h0c0,1.87-1.27,3.47-3.08,3.95-6.19,1.65-11.78,5.61-15.35,11.52-1.28,2.13-2.22,4.37-2.82,6.65-.48,1.8-2.08,3.05-3.94,3.05h0ZM110.52,143.55c0-1.86-1.26-3.47-3.05-3.94-2.29-.61-4.53-1.54-6.65-2.82-5.91-3.56-9.86-9.15-11.52-15.35-.48-1.8-2.08-3.08-3.95-3.08h0c-2.68,0-4.63,2.54-3.94,5.13,2.17,8.19,7.39,15.57,15.2,20.28,2.82,1.7,5.79,2.94,8.83,3.74,2.57.68,5.09-1.29,5.09-3.95h0ZM142.86,118.57c-1.86,0-3.47,1.26-3.94,3.05-.61,2.29-1.54,4.53-2.82,6.65-3.56,5.91-9.15,9.86-15.35,11.52-1.8.48-3.08,2.08-3.08,3.95h0c0,2.68,2.54,4.63,5.13,3.94,8.19-2.17,15.57-7.39,20.28-15.2,1.7-2.82,2.94-5.79,3.74-8.83.68-2.57-1.29-5.09-3.95-5.09h0ZM117.89,86.23c0,1.86,1.26,3.47,3.05,3.94,2.29.61,4.53,1.54,6.65,2.82,5.91,3.56,9.86,9.15,11.52,15.35.48,1.8,2.08,3.08,3.95,3.08h0c2.68,0,4.63-2.54,3.94-5.13-2.17-8.19-7.39-15.57-15.2-20.28-2.82-1.7-5.79-2.94-8.83-3.74-2.57-.68-5.09,1.29-5.09,3.95h0Z"
        />
      </g>
    </svg>
  );
};

export default BattleKartFootSVGIcon;
